module.exports = __webpack_public_path__ + "static/turtle-creek-house39-77fa14a9090ea8d7dcbe1c2f2842593e.jpg";